import { render, staticRenderFns } from "./transactionUi.vue?vue&type=template&id=11c8060a&scoped=true&"
import script from "./transactionUi.vue?vue&type=script&lang=js&"
export * from "./transactionUi.vue?vue&type=script&lang=js&"
import style0 from "./transactionUi.vue?vue&type=style&index=0&id=11c8060a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c8060a",
  null
  
)

export default component.exports